/*
 * @Author: lzh
 * @Date: 2021-08-26 15:51:18
 * @LastEditors: lbh
 * @LastEditTime: 2022-03-31 15:05:13
 * @Description: file content
 */
import axios from "axios";
import { Toast } from "vant";
import qs from "qs";
import myfn from "@/js/util.js";
import lang_ from "@/js/locales.js";
import MobileDetect from "mobile-detect";
import config from "../../package.json";

// 请求拦截器
axios.interceptors.request.use(
  config => {
    let contentType =
      config.headers["Content-Type"] ||
      config.headers["Content-type"] ||
      config.headers["content-type"] ||
      config.headers["content-Type"];
    if (
      config.method == "post" &&
      contentType.indexOf("application/x-www-form") > -1
    )
      config.data = qs.stringify(config.data);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 相应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      var code_ = parseInt(response.data.code);
      var respData = response.data;
      //  這裡需要判斷兩種不同的返回方式  A res.code = 1  B res.success = true
      if (
        myfn.ISNULL(respData.code) &&
        respData.success == false &&
        response.data.errCode != "REGISTERED.0002"
      ) {
        //  暫無處理
        // Toast({
        //   message: lang_.t("Network instability, please try again")
        // });
      } else if ((respData.code && respData.code != 1) || !respData.success) {
        var url = response.config.url;
        if (url.indexOf("updateMemberPhone") > -1) {
          if (code_ == -4) {
            Toast({
              message: lang_.t("SMS code not correct")
            });
          } else if (code_ == -2) {
            Toast({
              message: lang_.t("Invalid password")
            });
          }
        } else if (url.indexOf("loginOth") > -1) {
          Toast({
            message: lang_.t("Login error, user or password not correct")
          });
        } else if (
          url.indexOf("member/getMemberCoupon") == -1 &&
          (url.indexOf("system/sendSms") == -1 && response.data.code != -3) &&
          url.indexOf("joinBrand") == -1 &&
          url.indexOf("updateMemberInfo") == -1 &&
          url.indexOf("getBandName") == -1
        ) {
          if (response.data.errorMsg) {
            Toast({
              message: response.data.errorMsg
            });
          }
        }
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      return Promise.reject(error.response);
    }
  }
);

var https = {
  setHeaders(type) {
    var md = new MobileDetect(window.navigator.userAgent);
    var headers = {
      "Content-type": "application/x-www-form-urlencoded;charset=UTF-8",
      mobileToken: localStorage.randomWord,
      apptype: 13,
      apptype_old: 8,
      appVersion: config.version, //'1.0.0', // 程序版本號
      mobileModel: md.os(), // 系统 如 ios
      mobileVersion: md.os() + md.version(md.userAgent()), // 系统版本  如 ios11
      secretKey: "2309485937845783",
      product: md.mobile(), // 手机型号(名称)
      ver: md.os() + md.version(md.userAgent()) // 系统版本  如 ios11
    };
    if (type) headers["Content-type"] = type;
    return headers;
  },

  get(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          headers: this.setHeaders(),
          params: params
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },

  post(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: this.setHeaders()
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },

  /**
   * form 表单提交
   * @param {*} url
   * @param {*} params
   * @returns
   */
  form(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: this.setHeaders("multipart/form-data")
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  },
  /**
   * body
   * @param {*} url
   * @param {*} params
   * @returns
   */
  body(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, {
          headers: this.setHeaders("application/json")
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
    });
  }
};
export default https;



// WEBPACK FOOTER //
// ./src/js/http.js